import store from "@/store";

interface FileOptions {
    mimeType: string,
    base64: string,
    name: string
}

/**
 * Sets the isLoading property of the row object to true and dispatches an action to download a file.
 * @param {any} row - The row object representing a document.
 */
export const viewDocument = (row: any) => {
    row.isLoading = true
    store.dispatch('taskModule/uploadDocumentModule/downloadFile', {
        request: row.document,
        row: row,
        callback: viewDocumentResponse
    })
}
export const viewDocumentOrder = (row: any) => {
    row.isLoading = true
    store.dispatch('taskModule/uploadDocumentModule/downloadFile', {
        request: row.documentUpload,
        row: row,
        callback: viewDocumentResponse
    })
}

/**
 * Handles the response after downloading the file and opens it in a new tab if successful.
 * @param {any} response - The response object containing the file information.
 * @param {any} row - The row object representing a document.
 */
const viewDocumentResponse = async (response: any, row: any) => {
    if (response) {
      const { format, content, originalFileName } = response;
  
      const byteCharacters = atob(content);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: format });
      const url = URL.createObjectURL(blob);
  
      // Récupère l'extension du fichier (en minuscules)
      const fileExtension = originalFileName.split('.').pop()?.toLowerCase();
  
      // Définis les extensions à ouvrir vs à télécharger
      const justDownload = ['msg', 'docx', 'xlsx'];
      const justPreview = ['pdf', 'png', 'jpeg', 'jpg'];
  
      if (justDownload.includes(fileExtension)) {
        // Téléchargement seulement
        const a = document.createElement('a');
        a.href = url;
        a.download = originalFileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } else if (justPreview.includes(fileExtension)) {
        window.open(url, '_blank');
      } else {
        window.open(url, '_blank');
      }
  
      if (row) {
        row.isLoading = false;
      }
    }
  };
  
  function base64ToBlob(base64: string, mimeType: string): Blob {
    const byteCharacters = atob(base64);
    const byteArrays = [];
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }
    return new Blob([new Uint8Array(byteArrays)], { type: mimeType });
  }

/**
 * Opens the file in a new browser tab.
 * @param {Object} fileOptions - The file options containing the MIME type, base64 content, and name of the file.
 */
export const openFileInNewTab = (fileOptions: FileOptions) => {
    const {
        mimeType,
        base64,
        name
    } = fileOptions

    const linkSource = `data:${mimeType};base64,${base64}`;
    const newWindow = window.open("");
    if (newWindow) {
        newWindow.document.write(`
            <html>
            <head>
                <title>${name}</title>
                <style>
                    body {
                        margin: 0;
                        padding: 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 100vh;
                        background-color: #f0f0f0;
                    }
                    object {
                        max-width: 90%;
                        max-height: 90%;
                        border: 1px solid #ccc;
                        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                    }
                </style>
            </head>
            <body>
                <object type="${mimeType}" data="${linkSource}"></object>
            </body>
            </html>
        `);
        newWindow.document.close();
    }
}
